import { makeAutoObservable, runInAction } from 'mobx'
import { MultiPersonOrderingController } from '@ctrls/index'

enum TEMultiPersonDataType {
  Type_User = 'user',
  Type_CartItem = 'cartItem',
  Type_Remark = 'remark',
  Type_Person = 'person',
  Type_Kids = 'kids',
  Type_Address = 'address'
}

/** 多人点餐mobx */
class MultiPersonOrderingStore {
  constructor () {
    makeAutoObservable(this)
  }
  /** 多人点餐全局socket实例 */
  multiPersonSocket: MultiPersonOrderingController

  /** 多人点餐初始化数据 */
  multiPersonData = {} as IListMultiCartRes

  /** 连接多人点餐服务 */
  async connect (storeId: number, tableCode: number, fn?: (data: IListMultiCartRes) => any) {
    this.multiPersonSocket = new MultiPersonOrderingController(storeId, tableCode)
    this.initMultiCart(fn)
    // 监听页面显隐，重新拉取数据（解决socket断连问题）
    window.addEventListener('visibilitychange', () => {
      let hiddenTime = 0
      if (document.visibilityState === 'hidden') {
        hiddenTime = Date.now()
      } else {
        // 隐藏超过3s再拉取
        if ((Date.now() - hiddenTime) / 1000 > 3) {
          this.initMultiCart(fn)
        }
      }
    })
  }

  /** 连接多人点餐服务 */
  async connectTogether (buyTogetherId: string, fn?: (data: IListMultiCartRes) => any) {
    this.multiPersonSocket = new MultiPersonOrderingController(0, 0, buyTogetherId)
    this.initMultiCart(fn)

    // 监听页面显隐，重新拉取数据（解决socket断连问题）
    window.addEventListener('visibilitychange', () => {
      let hiddenTime = 0
      if (document.visibilityState === 'hidden') {
        hiddenTime = Date.now()
      } else {
        // 隐藏超过3s再拉取
        if ((Date.now() - hiddenTime) / 1000 > 3) {
          this.initMultiCart(fn)
        }
      }
    })
  }

  /** 初始化多人点餐数据 */
  async initMultiCart (fn?: (data: IListMultiCartRes) => any) {
    const res = await this.multiPersonSocket.getMultiCart()
    runInAction(() => {
      if (res && !res.error) {
        this.multiPersonData = res
      }
      fn?.(res)
    })
  }

  setMultiPersonData (data) {
    this.multiPersonData = data
  }

  /** 点餐人发生变化时触发 */
  onUserChange (fn: (data: any) => void) {
    function onChange (data) {
      if (data.operation.type === TEMultiPersonDataType.Type_User) {
        const { user, operation, person, cartItem, status, isOwner = false, address = null, eatType } = data
        fn({
          operation,
          user,
          person,
          status,
          syncCnt: cartItem?.cnt,
          address,
          eatType,
          isOwner
        })
      }
    }
    this.multiPersonSocket?.on('set', onChange)
    this.multiPersonSocket?.on('del', onChange)
  }

  /** 餐品发生变化时触发 */
  onCartItemChange (fn: (operation: TMultiPersonOperation, cartItems: TCartItem) => void) {
    function onChange (datas) {
      if (datas.operation && datas.operation.type === TEMultiPersonDataType.Type_CartItem) {
        fn(datas.operation, datas.cartItem)
      }
    }
    this.multiPersonSocket?.on('set', onChange)
    this.multiPersonSocket?.on('del', onChange)
    // this.multiPersonSocket?.on(operation.action, onChange)
    // this.multiPersonSocket?.on('change', onChange)
  }

  /** 餐品发生变化时触发 */
  // @action.bound
  onRemarkChange (fn: (data: string) => void) {
    function onChange (data) {
      // {addUser, value}
      if (data.operation && data.operation.type === TEMultiPersonDataType.Type_Remark) {
        fn(data.remark.value)
      }
    }
    this.multiPersonSocket?.on('set', onChange)
    this.multiPersonSocket?.on('del', onChange)
  }

  onPersonNumberChange (fn: (data: number) => void) {
    function onChange (data) {
      if (data.operation && data.operation.type === TEMultiPersonDataType.Type_Person) {
        fn(data.person.cnt)
      }
    }
    this.multiPersonSocket?.on('set', onChange)
  }

  emitOrder (data: object) {
    this.multiPersonSocket?.emit('order', data)
  }

  onOrderEmit (fn: (data: any) => void) {
    this.multiPersonSocket?.on('emit', (data) => {
      fn(data)
    })
  }

  /** 新增/删除餐品 */
  handleCartItem (action: TMultiPersonAction, data: ISyncCartItem) {
    this.multiPersonSocket?.update(action, TEMultiPersonDataType.Type_CartItem, data, data.pk)
  }

  /** 批量更新餐品 */
  handleBatchCartItem (action: TMultiPersonAction, data: ISyncCartItem[]) {
    this.multiPersonSocket?.batchUpdate(action, TEMultiPersonDataType.Type_CartItem, data)
  }

  /** 点餐人加入点餐room */
  addPerson (data: ISyncUser) {
    console.log(data, 'addPerson ===> multiPersonOrderingMobx')
    this.multiPersonSocket?.update('set', TEMultiPersonDataType.Type_User, data, data.personId)
  }

  /** 点餐人加入点餐room */
  delPerson (data: ISyncUser) {
    console.log(data, 'delPerson ===> multiPersonOrderingMobx')
    this.multiPersonSocket?.update('del', TEMultiPersonDataType.Type_User, data, data.personId)
  }

  /** 修改用餐人数 */
  handleUpdatePerson (data: { cnt: number }) {
    this.multiPersonSocket?.update('set', TEMultiPersonDataType.Type_Person, data, Math.floor((1 + Math.random()) * 0x100000000000).toString(36).substring(1))
  }

  handleRemark (data: {
    value: string;
    addUser: string;
  }) {
    this.multiPersonSocket?.update('set', TEMultiPersonDataType.Type_Remark, data)
  }

  /** 设置拼单参数 */
  handleOrderAddress (data: ISyncUser) {
    this.multiPersonSocket?.update('set', TEMultiPersonDataType.Type_Address, data, data.personId)
  }

  /** 清空多人点餐数据 */
  clearMultiCart () {
    return this.multiPersonSocket?.clearMultiCart()
  }
  /** 删除多人点餐房间 */
  delMultiRoom () {
    return this.multiPersonSocket?.delMultiRoom()
  }
}
export default new MultiPersonOrderingStore()
